import { Signal1 } from "@/js/util/event/Signal1";
import Disposable from "../util/disposable";

export default class Keyboard implements Disposable {
  public down: Signal1<KeyboardEvent>;
  public up: Signal1<KeyboardEvent>;

  constructor() {
    this.down = new Signal1<KeyboardEvent>();
    this.up = new Signal1<KeyboardEvent>();
    this._boundedListenerDown = this.onkeydown.bind(this);
    this._boundedListenerUp = this.onkeyup.bind(this);
    window.addEventListener("keydown", this._boundedListenerDown);
    window.addEventListener("keyup", this._boundedListenerUp);
  }

  public dispose(): void {
    window.removeEventListener("keydown", this._boundedListenerDown);
    window.removeEventListener("keyup", this._boundedListenerUp);
  }

  private onkeydown(e: KeyboardEvent) {
    this.down.emit(e);
  }

  private onkeyup(e: KeyboardEvent) {
    this.up.emit(e);
  }

  private _boundedListenerDown: (e: KeyboardEvent) => void;
  private _boundedListenerUp: (e: KeyboardEvent) => void;
}
